import { call, put, select } from 'redux-saga/effects';
import { updateDomainSettings } from '../../../../state/analytic/analyticAdminSlice';
import { selectUserCredentials } from '../../../../state/userCredential/userCredentialSlice';
import bugsnagClient from '../../../../services/bugsnag/bugsnag';
import { backendClient } from '../../../../services/api/backend-client';

export function* updateDomainSettingsSaga(action) {
    const { domain } = yield select(selectUserCredentials);
    try {
        const { data } = yield call(
            [backendClient, backendClient.patch],
            `admin/domains/${encodeURIComponent(domain)}/settings`,
            action.payload
        );
        yield put(updateDomainSettings(data));
    } catch (err) {
        bugsnagClient.notify(err);
        console.error('Failed to update domain settings', err?.response?.status, err?.message);
    }
}